import React from 'react';
import PropTypes from 'prop-types';
import { PlaceholderWithBtn } from '../elements-placeholder/placeholder';

export const ProjectPlaceholder = (props) => {
  const { activityData, projectLocation } = props;
  const { id, title } = activityData;
  const locationString = projectLocation.replace(/\,\s/g, '--').replace(/\s/g, '-');

  const activityURL = `/s/?a=${id}&location=${locationString}`;
  const activityText = `Find More ${title} Spaces`;

  return (
    <div className="container-fluid">
      <PlaceholderWithBtn
        icon="icon-full-heart"
        text="You haven't saved any spaces to this board."
        buttonText={ activityText }
        link={ activityURL }
      />
    </div>
  );
};

ProjectPlaceholder.propTypes = {
  activityData: PropTypes.object.isRequired,
  projectLocation: PropTypes.string.isRequired
};
